<app-sidenav>
  <ng-template #sidenavContent>
    <app-pdf-reactor-header>
      <app-card title="{{ 'content.this-order' | translate }}">
        @if (_thisOrder) {
          <div class="sidecard-content">
            <div class="sidecard-row">
              <div><strong>{{ 'content.language' | translate }}</strong></div>
              <div>{{ _thisOrder.lang }}</div>
            </div>
            <div class="sidecard-row">
              <div><strong>{{ 'content.reference-id' | translate }}</strong></div>
              <div>{{ _thisOrder.ref }}</div>
            </div>
            @if (isConsumerRequestReport(inputData) && mergeSubjectIdentifiers(inputData.report?.consumers).length > 0) {
              <div class="sidecard-row">
                <div><strong>{{ 'content.identifier' | translate }}</strong></div>
                <div>{{ mergeSubjectIdentifiers(inputData.report?.consumers).join(', ') }}</div>
              </div>
            }
            <div class="sidecard-row">
              <div><strong>{{ 'content.branch' | translate }}</strong></div>
              <div>{{ _thisOrder.branch }}</div>
            </div>
            <div class="sidecard-row">
              <div><strong>{{ 'content.results-issued' | translate }}</strong></div>
              <div>{{ reformatDate(_thisOrder.resultsIssued, "LLL") }}</div>
            </div>
          </div>
        }
      </app-card>
    </app-pdf-reactor-header>
  </ng-template>
  <ng-template #mainContent>
    <div class="ifs-content-wrapper">
      @if (_appCard && _creditReport) {
        <app-pdf-button-bar
          newOrderUrl="/consumer-services"
          [css]="ifsReportCss"
        [documentRootElement]="[_appCard, _creditReport]"></app-pdf-button-bar>
      }
      <p>{{ 'content.results-displayed-below' | translate:{heading: '' | translate} }}</p>
      <app-ifs-report-content [ifsReport]="ifsReport"
        [inputData]="inputData"
        (creditReport)="creditReport = $event"
      (thisOrder)="thisOrder = $event"></app-ifs-report-content>
    </div>
  </ng-template>
</app-sidenav>
